/**
 * AdminDashboard — autenticazione Phase 6 (IMPL-P6-007).
 *
 * Placeholder landing for ADMIN users. Wrapped in
 * `RequireAuth roles={['ADMIN']}` so anonymous visitors are redirected to
 * `/accedi?redirectTo=/admin` and non-ADMIN roles are bounced to `/`.
 */
import { Link } from 'react-router-dom';
import { CalendarClock } from 'lucide-react';
import { AppLayout } from '@/components/layout/AppLayout';
import { RequireAuth } from '@/features/auth/components/RequireAuth';

export function AdminDashboard() {
  return (
    <RequireAuth roles={['ADMIN']}>
      <AppLayout>
        <section className="space-y-6">
          <div className="space-y-1">
            <h1 className="text-3xl font-semibold tracking-tight">Dashboard Admin</h1>
            <p className="text-muted-foreground">Pannello di controllo amministrativo.</p>
          </div>

          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <Link
              to="/admin/scadenze"
              className="flex items-start gap-4 rounded-lg border p-4 hover:bg-muted/40 transition-colors"
            >
              <CalendarClock className="mt-0.5 h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
              <div>
                <p className="font-medium">Scadenze contrattuali</p>
                <p className="text-sm text-muted-foreground">
                  Tutte le pratiche attive con data di scadenza cross-tenant.
                </p>
              </div>
            </Link>
          </div>
        </section>
      </AppLayout>
    </RequireAuth>
  );
}
